import { Link } from "react-router-dom";
import { Ship, Mail, MapPin, Globe } from "lucide-react";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0B2545] text-white" data-testid="footer">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <Link to="/" className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-[#F59E0B] flex items-center justify-center">
                <Ship className="w-6 h-6 text-[#0B2545]" />
              </div>
              <div>
                <span className="heading-font text-lg font-bold tracking-tight">SKY CARGO</span>
                <span className="heading-font text-lg font-bold text-[#F59E0B] tracking-tight"> DELIVERY</span>
              </div>
            </Link>
            <p className="text-slate-400 text-sm leading-relaxed mb-4">
              Your trusted partner for global logistics solutions. We deliver excellence 
              across sea, air, and land freight services.
            </p>
            <div className="flex items-center gap-2 text-sm text-slate-400">
              <Globe className="w-4 h-4 text-[#F59E0B]" />
              <span>skycargodelivery.com</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="heading-font text-lg font-bold uppercase tracking-tight mb-6">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/" 
                  className="text-slate-400 hover:text-[#F59E0B] transition-colors text-sm"
                  data-testid="footer-link-home"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link 
                  to="/services" 
                  className="text-slate-400 hover:text-[#F59E0B] transition-colors text-sm"
                  data-testid="footer-link-services"
                >
                  Our Services
                </Link>
              </li>
              <li>
                <Link 
                  to="/about" 
                  className="text-slate-400 hover:text-[#F59E0B] transition-colors text-sm"
                  data-testid="footer-link-about"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="text-slate-400 hover:text-[#F59E0B] transition-colors text-sm"
                  data-testid="footer-link-contact"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="heading-font text-lg font-bold uppercase tracking-tight mb-6">
              Services
            </h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/services" 
                  className="text-slate-400 hover:text-[#F59E0B] transition-colors text-sm"
                >
                  Sea Freight
                </Link>
              </li>
              <li>
                <Link 
                  to="/services" 
                  className="text-slate-400 hover:text-[#F59E0B] transition-colors text-sm"
                >
                  Air Freight
                </Link>
              </li>
              <li>
                <Link 
                  to="/services" 
                  className="text-slate-400 hover:text-[#F59E0B] transition-colors text-sm"
                >
                  Land Freight
                </Link>
              </li>
              <li>
                <Link 
                  to="/services" 
                  className="text-slate-400 hover:text-[#F59E0B] transition-colors text-sm"
                >
                  Warehousing
                </Link>
              </li>
              <li>
                <Link 
                  to="/services" 
                  className="text-slate-400 hover:text-[#F59E0B] transition-colors text-sm"
                >
                  Courier Service
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="heading-font text-lg font-bold uppercase tracking-tight mb-6">
              Contact Us
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin className="w-5 h-5 text-[#F59E0B] flex-shrink-0 mt-0.5" />
                <span className="text-slate-400 text-sm">
                  VISSERINGWEG 11<br />
                  1112 AS AMSTERDAM<br />
                  THE NETHERLANDS
                </span>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#F59E0B] flex-shrink-0 mt-0.5" />
                <div className="text-sm">
                  <a 
                    href="mailto:helpdesk@skycargodelivery.com" 
                    className="text-slate-400 hover:text-[#F59E0B] transition-colors block"
                  >
                    helpdesk@skycargodelivery.com
                  </a>
                  <a 
                    href="mailto:info@skycargodelivery.com" 
                    className="text-slate-400 hover:text-[#F59E0B] transition-colors block"
                  >
                    info@skycargodelivery.com
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-slate-400">
              &copy; {currentYear} Sky Cargo Delivery. All rights reserved.
            </p>
            <div className="flex items-center gap-6 text-sm text-slate-400">
              <span>Privacy Policy</span>
              <span>Terms of Service</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
